import { Injectable, inject, DOCUMENT } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CookieWrapper {
  private document = inject(DOCUMENT);

  set(name: string, value: string, days = 365, path = '/'): void {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    this.document.cookie = `${name}=${value}; expires=${expires}; path=${path}`;
  }

  get(name: string): string | null {
    return (
      this.document.cookie
        .split('; ')
        .find(row => row.startsWith(name + '='))
        ?.split('=')[1] || null
    );
  }

  delete(name: string, path = '/'): void {
    this.document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}`;
  }

  check(name: string): boolean {
    return this.document.cookie
      .split('; ')
      .some(row => row.startsWith(name + '='));
  }
}
